import { Application } from "@hotwired/stimulus";

window.Stimulus = Application.start();
Stimulus.debug = true
const modules = import.meta.glob("./**/*_controller.js", { eager: true });
for (const path in modules) {
    const controller = modules[path].default;
    const name = path
        .replace("./", "")
        .replace("_controller.js", "")
        .replace(/\//g, "--");
    Stimulus.register(name, controller);
}
